<template>
  <div :data-zone-name="props.name" data-component-name="VZone" class="contents">
    <slot />
  </div>
</template>
<script setup lang="ts">
import type { V } from '@utils/types';

defineOptions({
  name: 'VZone'
})

const props = defineProps<{
  name: V.Zone
}>()
</script>
